export default "__VITE_ASSET__BzaFRXQ1__"